import React from 'react';

import DpeVision from '../../components/Prospecting/DpeVision';


function DpeVisionView() {
  return (
    <DpeVision />
  );
}

export default DpeVisionView;
